module.exports = __webpack_public_path__ + "static/media/whatsapp-real.62ba0a1e.svg";